import {
  FETCHING_CREATED_FORMS, FETCHING_CREATED_FORMS_SUCCEEDED, FETCHING_CREATED_FORMS_FAILED,
  FORM_MANAGE_VIEW, INVALIDATE_FORMS, FETCHING_FORM_REQUEST, FETCHING_FORM_SUCCEEDED, FETCHING_FORM_FAILED
} from 'constants/actionTypes';

import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const FORM_URL = `${apiUrl}/forms`;

/**
 * Fetch Created Forms 
 */
export const fetchCreatedForms = createAction(FETCHING_CREATED_FORMS, (page, limit, type) => {
  return {
    page: page,
    limit: limit,
    type: type
  }
});

const fetchCreatedFormsSucceeded = createAction(FETCHING_CREATED_FORMS_SUCCEEDED, (response) => {
  return response;
})

const fetchCreatedFormsFailed = createAction(FETCHING_CREATED_FORMS_FAILED, (error) => {
  return error;
})

function* fetchCreatedFormsSaga(action) {
  const { page, limit, type } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(FORM_URL, {
    queryParams: params
  });

  const fetchCreatedFormAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchCreatedFormAPI);
    if (response) {
      yield put(fetchCreatedFormsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchCreatedFormsFailed(error));
  }
}

/**
 * Toggle Form Manage View 
 */
export const toggleFormManageView = createAction(FORM_MANAGE_VIEW, (isFormManageView) => {
  return {
    isFormManageView: isFormManageView
  }
})

export const invalidateForms = createAction(INVALIDATE_FORMS);

/**
 * Fetch form
 */
export const fetchForm = createAction(FETCHING_FORM_REQUEST, (formId) => {
  return {
    formId: formId
  }
})

const fetchingFormSucceeded = createAction(FETCHING_FORM_SUCCEEDED, (response) => {
  return {
    response: response
  }
})

const fetchingFormFailed = createAction(FETCHING_FORM_FAILED, (formId, error) => {
  return {
    formId: formId,
    error: error
  }
})

function* fetchFormSaga(action) {
  const { formId } = action.payload;

  let url = buildUrl(FORM_URL, {
    path: `/${formId}`
  });

  const fetchFormAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchFormAPI);
    if (response) {
      yield put(fetchingFormSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingFormFailed(formId, error));
  }
}

export default function* formsSaga() {
  yield takeEvery(FETCHING_CREATED_FORMS, fetchCreatedFormsSaga)
  yield takeEvery(FETCHING_FORM_REQUEST, fetchFormSaga)
}